var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 6.38542C10.8458 6.38542 11.5312 7.07083 11.5312 7.91667C11.5312 8.7625 10.8458 9.44792 9.99999 9.44792C9.15416 9.44792 8.46874 8.7625 8.46874 7.91667C8.46874 7.07083 9.15416 6.38542 9.99999 6.38542ZM9.99999 12.9479C12.1656 12.9479 14.4479 14.0125 14.4479 14.4792V14.8462H5.55207V14.4792C5.55207 14.0125 7.83437 12.9479 9.99999 12.9479ZM9.99999 5C8.38853 5 7.08332 6.30521 7.08332 7.91667C7.08332 9.52813 8.38853 10.8333 9.99999 10.8333C11.6114 10.8333 12.9167 9.52813 12.9167 7.91667C12.9167 6.30521 11.6114 5 9.99999 5ZM9.99999 11.5625C8.05312 11.5625 4.16666 12.5396 4.16666 14.4792V15.8333H15.8333V14.4792C15.8333 12.5396 11.9469 11.5625 9.99999 11.5625Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 2.5H0.833344V15.8333H6.66668V17.5H13.3333V15.8333H19.1583L19.1667 2.5ZM17.5 14.1667H2.50001V4.16667H17.5V14.1667Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.60031964.svg";
export { ForwardRef as ReactComponent };